module.exports = __webpack_public_path__ + "/img/Standoff-Male-Female-Labeled-JxaVV3.svg";